import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const TeamMemberCard = ({ member }) => {
  return (
    <div className="group relative p-1 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] rounded-2xl hover:scale-105 transition-all duration-500">
      <div className="bg-white p-6 rounded-xl h-full">
        {/* Image container with decorative elements */}
        <div className="relative mb-6">
          {/* Decorative circle */}
          <div className="absolute -right-2 -top-2 w-20 h-20 rounded-full border-2 border-[#4897d2]/30
                        group-hover:scale-110 transition-transform duration-500" />

          <div className="relative w-28 h-28 mx-auto overflow-hidden rounded-full border-4 border-white shadow-xl">
            {member.photo_url ? (
              <img
                src={member.photo_url}
                alt={`${member.first_name} ${member.last_name}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-[#662d91] to-[#28c4f4] flex items-center justify-center">
                <span className="text-2xl font-bold text-white">
                  {member.first_name[0]}{member.last_name[0]}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="text-center">
          <h3 className="text-lg font-bold mb-1 text-gray-900">
            {member.first_name} {member.last_name}
          </h3>
          <p className="text-sm font-medium text-[#4897d2] mb-3">
            {member.role}
          </p>

          {/* Description with line clamp */}
          <p className="text-gray-600 text-sm line-clamp-3 mb-4 h-[4.5em]">
            {member.description}
          </p>

          {/* Social media links */}
          <div className="flex justify-center space-x-4 pt-3 border-t">
            {member.instagram && (
              <a
                href={member.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-600 hover:text-pink-700 transition-colors"
              >
                <Instagram size={18} />
              </a>
            )}
            {member.facebook && (
              <a
                href={member.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-700 transition-colors"
              >
                <Facebook size={18} />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberCard;
